// src/components/SuccessPopup.js

function Success({ message, onClose }) {
  return (
    <div
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        backgroundColor: "rgba(0,0,0,0.4)", // overlay
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        zIndex: 9999,
      }}
    >
      <div
        style={{
          backgroundColor: "#fff",
          borderRadius: "12px",
          padding: "30px",
          maxWidth: "400px",
          width: "90%",
          textAlign: "center",
          boxShadow: "0 4px 12px rgba(0,0,0,0.2)",
        }}
      >
        <h3 style={{ marginBottom: "10px", fontSize: "22px", fontWeight: "600" }}>
Hey ! your listing has been submitted successfully
        </h3>
        <p style={{ marginBottom: "25px", fontSize: "16px", color: "#333" }}>
          {message}
        </p>
        <button
          onClick={onClose}
          style={{
            display: "inline-block",
            background: "black",
            color: "#fff",
            border: "none",
            padding: "12px 24px",
            borderRadius: "25px",
            cursor: "pointer",
            fontSize: "15px",
            fontWeight: "500",
          }}
        >
          Explore Experiences
        </button>
      </div>
    </div>
  );
}

export default Success;
